import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const navItems = [
  { path: '/', label: 'Demandes' },
  { path: '/submit', label: 'Soumettre' },
];

export function Layout({ isAdmin, isMember, userName, isLoggedIn }: { isAdmin: boolean; isMember: boolean; userName: string; isLoggedIn: boolean }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <header style={{ background: '#0078d4', color: '#fff', padding: '0 24px', display: 'flex', alignItems: 'center', height: 56 }}>
        <h1 style={{ fontSize: 18, margin: 0, marginRight: 32 }}>CLARA UserVoice</h1>
        <nav style={{ display: 'flex', gap: 4 }}>
          <NavLink to="/"
            style={({ isActive }) => ({
              padding: '8px 16px', borderRadius: 4, color: '#fff', textDecoration: 'none', fontSize: 14,
              background: isActive ? 'rgba(255,255,255,0.2)' : 'transparent',
            })}>
            Demandes
          </NavLink>
          {isMember && (
            <NavLink to="/submit"
              style={({ isActive }) => ({
                padding: '8px 16px', borderRadius: 4, color: '#fff', textDecoration: 'none', fontSize: 14,
                background: isActive ? 'rgba(255,255,255,0.2)' : 'transparent',
              })}>
              Soumettre
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/admin"
              style={({ isActive }) => ({
                padding: '8px 16px', borderRadius: 4, color: '#fff', textDecoration: 'none', fontSize: 14,
                background: isActive ? 'rgba(255,255,255,0.2)' : 'transparent',
              })}>
              Admin
            </NavLink>
          )}
          {isAdmin && (
            <NavLink to="/support/submit"
              style={({ isActive }) => ({
                padding: '8px 16px', borderRadius: 4, color: '#fff', textDecoration: 'none', fontSize: 14,
                background: isActive ? 'rgba(255,255,255,0.2)' : 'transparent',
              })}>
              Support
            </NavLink>
          )}
        </nav>
        <div style={{ marginLeft: 'auto', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
          {isLoggedIn ? (
            <>
              {userName && <span>Bonjour {userName}</span>}
              {isAdmin && <span style={{ padding: '2px 8px', borderRadius: 10, background: 'rgba(255,255,255,0.2)', fontSize: 11 }}>Admin</span>}
              <a href="/.auth/logout" style={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 12, marginLeft: 8 }}>Deconnexion</a>
            </>
          ) : (
            <a href="/.auth/login/aad" style={{ color: '#fff', textDecoration: 'none', padding: '6px 16px', borderRadius: 4, background: 'rgba(255,255,255,0.2)' }}>
              Se connecter
            </a>
          )}
        </div>
      </header>
      <main style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
        <Outlet />
      </main>
    </div>
  );
}
